// Module
var code = "<tr> <td> <div class=pushAvatar style=\"background-image:url(<%= nick_img %>)\"> </div> <%- partner_id %> </td> <td class=text-right><%- parseFloat(revenue).toLocaleString('en-US',{style:'currency','currency':'USD'}) %></td> </tr> ";
// Exports
module.exports = code;